export default __webpack_public_path__ + "static/O0281-5b8a3bd57739261351b85360e42bb0da.png";